import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { reFormatDate } from "../../../../utils/utils";
import { groupTransactions } from "../../../../comps/Accounts/BackEnd/AccountingRPT/accountingRPTTableItems";
import { TotalsAccounts } from "./BodyA";
import { stElemnt } from "../../../../St/Reviews/cStyle";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));


export default function BodyItems(props) {
    const { data, isLast, infoData
    } = props;
    const stylRo = {
        ...stElemnt.AF.cell,
        padding: "0px 1px",
    }
    const st_name = {
        width: "32%",
        padding: "0px 0px",
        textAlign: "-webkit-center",
        margin: "0px",
        fontSize: "11px",
        border: "solid 0.1px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
    }
    const { t } = useTranslation(["forms"]);
    const classes = useStyles();
    const styleH = {
        ...stElemnt.AF.header,
        backgroundColor: colors.grey[100],
        fontWeight: "bold",
        paddingTop: "2px",
        paddingBottom: "2px",
        border: "solid 0px",
        border: "solid 0.1px",
    };
    return (
        <div>
            <TableContainer
                component={Paper}
                elevation={0}
                sx={{
                    width: "100%",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    overflow: "hidden",
                    direction: "rtl",
                    backgroundColor: "#fff",

                    "@media print": {
                        border: "1px solid #999",
                        borderRadius: 0,
                        boxShadow: "none",
                        overflow: "visible",
                    },
                }}
            >
                <Table
                    size="small"
                    sx={{
                        width: "100%",
                        borderCollapse: "collapse",
                        tableLayout: "fixed",
    
                        "& th": {
                            backgroundColor: "#f3f4f6",
                            color: "#222",
                            fontWeight: 700,
                            fontSize: "11px",
                            padding: "0px 0px",
                            borderBottom: "1.5px solid #777",
                            borderLeft: "1px solid #ddd",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                        },
    
                        "& td": {
                            fontSize: "10.5px",
                            color: "#222",
                            padding: "0px",
                            borderBottom: "1px solid #e2e2e2",
                            borderLeft: "1px solid #e5e5e5",
                            verticalAlign: "middle",
                        },
    
                        "& tbody tr:hover": {
                            backgroundColor: "#fafafa",
                        },
    
                        "& tbody tr:last-child td": {
                            borderBottom: "1px solid #999",
                        },
    
                        "@media print": {
                            "& th": {
                                backgroundColor: "#f1f1f1 !important",
                                WebkitPrintColorAdjust: "exact",
                                printColorAdjust: "exact",
                                fontSize: "9.5px",
                                padding: "0px 0px",
                                borderBottom: "1px solid #555",
                            },
    
                            "& td": {
                                fontSize: "9px",
                                padding: "0px",
                                borderBottom: "1px solid #ccc",
                            },
    
                            "& tbody tr": {
                                pageBreakInside: "avoid",
                                breakInside: "avoid",
                            },
                        },
                    }}
                >

                    {/* ================= HEADER ================= */}

                    <TableHead>
                        <TableRow>

                            <TableCell style={styleH}
                                sx={{
                                    width: "25%",
                                }}
                            >
                                {t("note")}{" "}
                            </TableCell>
                            <TableCell style={styleH}
                                sx={{
                                    width: "15%",
                                    textAlign: "right !important",
                                }}
                            >
                                {t("date")}{" "}
                            </TableCell>
                            <TableCell style={styleH}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {"رقم المستند"}
                            </TableCell>

                            <TableCell style={styleH}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("dept")}
                            </TableCell>
                            <TableCell style={styleH}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("credit")}{" "}
                            </TableCell>

                            <TableCell style={styleH}
                                sx={{
                                    width: "15%",
                                }}
                            >
                                {t("balance")}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {/* مثال سجل */}
                        {data.map((row, i) => (
                            <>
                                <TableRow>

                                    <TableCell align="center" style={stylRo}>
                                        {row.notes}
                                    </TableCell>

                                    <TableCell style={stylRo}>
                                        {row?.doc_no}
                                    </TableCell>

                                    <TableCell align="center" style={stylRo}>
                                        {row.date != null ? reFormatDate(row?.date) : ""}
                                    </TableCell>

                                    <TableCell style={stylRo}>
                                        {row.dept.toFixed(2)}
                                    </TableCell>

                                    <TableCell align="left" style={stylRo}>
                                        {row.credit.toFixed(2)}
                                    </TableCell>

                                    <TableCell align="left" style={stylRo}>
                                        {row.Balance?.toFixed(2)}
                                    </TableCell>
                                </TableRow>


                                {/* ================= تفاصيل الأصناف ================= */}
                                {[1, 2, 3, 4].includes(row.type) == 1 && row.items?.length > 0 &&
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            sx={{
                                                padding: "5px 15px !important",
                                                backgroundColor: "#fafafa",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            <TableContainer
                                                component={Paper}
                                                elevation={0}
                                                sx={{
                                                    width: "88%",
                                                    marginRight: "auto",
                                                    border: "1px solid #dedede",
                                                    borderRadius: "4px",
                                                    overflow: "hidden",
                                                }}
                                            >

                                                <Table
                                                    size="small"
                                                    sx={{
                                                        tableLayout: "fixed",

                                                        "& th": {
                                                            backgroundColor: "#f8f8f8",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            padding: "4px 6px",
                                                            borderBottom: "1px solid #aaa",
                                                        },

                                                        "& td": {
                                                            fontSize: "12px",
                                                            padding: "3px 6px",
                                                            fontWeight: "bold",
                                                            borderBottom: "1px dotted #d5d5d5",
                                                        },

                                                        "& tr:last-child td": {
                                                            borderBottom: 0,
                                                        },

                                                        "@media print": {
                                                            "& th": {
                                                                fontSize: "12px",
                                                                padding: "3px 5px",
                                                                fontWeight: "bold",

                                                            },

                                                            "& td": {
                                                                fontSize: "10px",
                                                                fontWeight: "bold",
                                                                padding: "2px 5px",
                                                            },
                                                        },
                                                    }}
                                                >

                                                    <TableHead>
                                                        <TableRow>

                                                            <TableCell style={{ backgroundColor: colors.green[200], fontWeight: "bold" }}>
                                                                اسم الصنف
                                                            </TableCell>

                                                            <TableCell style={{ backgroundColor: colors.green[200], fontWeight: "bold" }}
                                                                align="center"
                                                                sx={{ width: "20%" }}

                                                            >
                                                                الكمية
                                                            </TableCell>

                                                            <TableCell style={{ backgroundColor: colors.green[200], fontWeight: "bold" }}
                                                                align="left"
                                                                sx={{ width: "20%" }}
                                                            >
                                                                السعر
                                                            </TableCell>

                                                        </TableRow>
                                                    </TableHead>

                                                    {row.items.map((row, i) => (
                                                        <TableBody>

                                                            <TableRow>

                                                                <TableCell>
                                                                    {row.ItemName}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {row.Qty?.toFixed(2)}
                                                                </TableCell>

                                                                <TableCell align="left">
                                                                    {row.price?.toFixed(2)}
                                                                </TableCell>

                                                            </TableRow>

                                                        </TableBody>
                                                    ))}

                                                </Table>

                                            </TableContainer>

                                        </TableCell>

                                    </TableRow>
                                }
                            </>
                        ))}

                    </TableBody>


                </Table>
            </TableContainer>
            {isLast && <TotalsAccounts infoData={infoData} />}
        </div>
    );
}
